export const michigan = {
  "26000": "Michigan",
  "26001": "Alcona County",
  "26003": "Alger County",
  "26005": "Allegan County",
  "26007": "Alpena County",
  "26009": "Antrim County",
  "26011": "Arenac County",
  "26013": "Baraga County",
  "26015": "Barry County",
  "26017": "Bay County",
  "26019": "Benzie County",
  "26021": "Berrien County",
  "26023": "Branch County",
  "26025": "Calhoun County",
  "26027": "Cass County",
  "26029": "Charlevoix County",
  "26031": "Cheboygan County",
  "26033": "Chippewa County",
  "26035": "Clare County",
  "26037": "Clinton County",
  "26039": "Crawford County",
  "26041": "Delta County",
  "26043": "Dickinson County",
  "26045": "Eaton County",
  "26047": "Emmet County",
  "26049": "Genesee County",
  "26051": "Gladwin County",
  "26053": "Gogebic County",
  "26055": "Grand Traverse County",
  "26057": "Gratiot County",
  "26059": "Hillsdale County",
  "26061": "Houghton County",
  "26063": "Huron County",
  "26065": "Ingham County",
  "26067": "Ionia County",
  "26069": "Iosco County",
  "26071": "Iron County",
  "26073": "Isabella County",
  "26075": "Jackson County",
  "26077": "Kalamazoo County",
  "26079": "Kalkaska County",
  "26081": "Kent County",
  "26083": "Keweenaw County",
  "26085": "Lake County",
  "26087": "Lapeer County",
  "26089": "Leelanau County",
  "26091": "Lenawee County",
  "26093": "Livingston County",
  "26095": "Luce County",
  "26097": "Mackinac County",
  "26099": "Macomb County",
  "26101": "Manistee County",
  "26103": "Marquette County",
  "26105": "Mason County",
  "26107": "Mecosta County",
  "26109": "Menominee County",
  "26111": "Midland County",
  "26113": "Missaukee County",
  "26115": "Monroe County",
  "26117": "Montcalm County",
  "26119": "Montmorency County",
  "26121": "Muskegon County",
  "26123": "Newaygo County",
  "26125": "Oakland County",
  "26127": "Oceana County",
  "26129": "Ogemaw County",
  "26131": "Ontonagon County",
  "26133": "Osceola County",
  "26135": "Oscoda County",
  "26137": "Otsego County",
  "26139": "Ottawa County",
  "26141": "Presque Isle County",
  "26143": "Roscommon County",
  "26145": "Saginaw County",
  "26147": "St. Clair County",
  "26149": "St. Joseph County",
  "26151": "Sanilac County",
  "26153": "Schoolcraft County",
  "26155": "Shiawassee County",
  "26157": "Tuscola County",
  "26159": "Van Buren County",
  "26161": "Washtenaw County",
  "26163": "Wayne County",
  "26165": "Wexford County",
};
